import { render, staticRenderFns } from "./PopularRecommend.vue?vue&type=template&id=15528173&scoped=true"
import script from "./PopularRecommend.vue?vue&type=script&lang=js"
export * from "./PopularRecommend.vue?vue&type=script&lang=js"
import style0 from "./PopularRecommend.vue?vue&type=style&index=0&id=15528173&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15528173",
  null
  
)

export default component.exports